import { render, staticRenderFns } from "./claim-payment.vue?vue&type=template&id=394ead68&"
import script from "./claim-payment.vue?vue&type=script&lang=js&"
export * from "./claim-payment.vue?vue&type=script&lang=js&"
import style0 from "./claim-payment.vue?vue&type=style&index=0&id=394ead68&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports